import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from '@/redux/store'

const userAuthenticatedSelector = (state: RootState) => state.auth

export const userAuthenticated = createSelector(
  userAuthenticatedSelector,
  authState => authState.isAuthenticated
)
export const userRoles = createSelector(
  userAuthenticatedSelector,
  authState => authState.userRoles
)
export const userUsername = createSelector(
  userAuthenticatedSelector,
  authState => authState.username
)
export const userAuthenticatedLoading = createSelector(
  userAuthenticatedSelector,
  authState => authState.loading
)
